import { OptionsDataType } from "../../../components/select/MuiSelect";

export const ProgramTemplateSearchFormKey = {
  programTemplateNameFilter: "programTemplateNameFilter",
  programTemplateName: "programTemplateName",
  lineOfBusiness: "lineOfBusiness",
  programFrameWork: "programFrameWork",
  status: "status",
  country: "country",
} as const;

export interface ProgramTemplateSearchFormProps {
  programTemplateNameFilter: string;
  programTemplateName: string;
  lineOfBusiness: string;
  programFrameWork: string;
  status: string;
  country: string[];
}

export interface ProgramArrayList {
  id: string;
  name: string;
}

export interface OptionListType extends Array<OptionsDataType> {}

export interface SearchProgramTemplate {
  id: string;
  name: string;
  lineOfBusiness: string;
  programClass: string;
  solutionCategory: string;
  solutionCategoryLob: string;
  status: string;
  countryId: string[];
  createdDate: string;
}

export interface SearchProgramTemplateResultRowValue {
  id: string;
  name: string;
  lineOfBusiness: string;
  programFrameWork: string;
  solutionCategory: string;
  solutionCategoryLob: string;
  status: string;
  countryId: string[];
  countryName:string[];
  createdDate: string;
  [key: string]: any;
}

export const SearchProgramTemplateResultFormKey = {
  name: "name",
  lineOfBusiness: "lineOfBusiness",
  programFrameWork: "programFrameWork",
  solutionCategory: "solutionCategory",
  solutionCategoryLob: "solutionCategoryLob",
  status: "status",
  countryId: "countryId",
  countryName:"countryName",
  createdDate: "createdDate",
  tableBody: "tableBody",
  tableRow: "tableRow",
  tableFooter: "tableFooter",
  tablePagination: "tablePagination",
} as const;
